<template>
    <div>
        <div v-show="advancedFiltersAreShown">
            <slot></slot>
        </div>
        <span class="clickable-item text-muted" v-if="!advancedFiltersAreShown" @click="changeShown">
            <i class="fa fa-angle-down"></i> 显示更多过滤条件
            </span>
        <span class="clickable-item text-muted" v-if="advancedFiltersAreShown" @click="changeShown">
            <i class="fa fa-angle-up"></i> 隐藏更多过滤条件
        </span>
    </div>
</template>
<script>
    export default {
        name: "fpFilterHidePanel",
        data() {
            return {
                advancedFiltersAreShown: false
            }
        },
        methods: {
            changeShown() {
                this.advancedFiltersAreShown = !this.advancedFiltersAreShown;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FilterHidePanel.vue?648b5a80